import { Icon, Input, InputGroup, InputGroupProps, InputProps, LEGACY_MODE, useMode } from '../chakra';
import { MdSearch } from '../icons';

export interface SearchInputProps extends Omit<InputGroupProps, 'children'> {
  inputProps?: Omit<InputProps, 'type'> & { 'data-testid'?: string };
}

export function SearchInput({ inputProps, ...props }: SearchInputProps) {
  const { mode } = useMode();
  return (
    <InputGroup {...props} startElement={<Icon as={MdSearch} boxSize={mode === LEGACY_MODE ? undefined : 5} />}>
      <Input type="search" {...inputProps} />
    </InputGroup>
  );
}
